// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__ypt0U","subtitleContainer":"header_subtitleContainer__1yR9k"};